import { Component, Input, OnInit } from "@angular/core";
import { BaseComponent, UserService, HelperService, WindowService, FenderShopifyOrder, OrderService, Order, AdminService } from "@mypxplat/xplat/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";
import moment from "moment";

@Component({
  selector: "myp-account-orders",
  templateUrl: "./orders.component.html",
  standalone: false,
})
export class AccountOrdersComponent extends BaseComponent implements OnInit {
  @Input() admin: boolean = false;
  @Input() userDetails: any;

  public loading: boolean;
  public orders: Array<any>;
  public orderMetadata: any = {};
  public selectedOrder: Order;
  private filterFn: (order: any) => boolean;
  public filteredOrders: any[];
  private searchTerm: string = "";
  constructor(
    public userService: UserService,
    public helperService: HelperService,
    private _win: WindowService,
    private _router: Router,
    private _route: ActivatedRoute,
    public appService: AppService,
    public orderService: OrderService,
    public adminService: AdminService
  ) {
    super(userService);
    this.filterFn = this.createFilterFunction();
  }

  ngOnInit() {
    this.loading = true;
    if (!this.orders) {
      if (this.admin) {
        this.adminService.getAllUserOrders(this.userDetails.email, this.userDetails.id).subscribe((result: any) => {
          this.orders = result;
          this.loading = false;
          this.filterOrders();
          this.sortOrders();
        });
      } else {
        this.orderService.getAllUserOrders(this.userService.user.email).subscribe((result: any) => {
          this.orders = result;
          this.loading = false;
          this.filterOrders();
          this.sortOrders();
        });
      }
    }
  }

  private createFilterFunction(): (order: any) => boolean {
    // Create a more predictable function that the browser can optimize
    return (order: any) => {
      if (!order) return false;

      const searchTerm = this.searchTerm;
      if (!searchTerm) return true;
      if (order.id?.toString().toLowerCase().includes(searchTerm)) return true;
      if (order.name?.toString().toLowerCase().includes(searchTerm)) return true;
      if (order.description?.toString().toLowerCase().includes(searchTerm)) return true;

      // Check details
      if (order.items?.length) {
        for (const detail of order.items) {
          if (detail.title?.toLowerCase().includes(searchTerm) || detail.variantTitle?.toLowerCase().includes(searchTerm) || detail.sku?.toLowerCase().includes(searchTerm)) {
            return true;
          }
        }
      }

      return false;
    };
  }

  selectOrder(order: Order) {
    this.selectedOrder = order;
  }

  goToOrderDetail(order: Order) {
    this._router.navigate(["/account/orders", order.id]);
  }

  public filtering: boolean;
  filterOrders(args?: string) {
    this.filtering = !!args;
    this.searchTerm = args?.toLowerCase() || "";
    // Use the pre-compiled filter function
    this.filteredOrders = this.orders.filter(this.filterFn);
  }

  sortOrders() {
    if (!this.filteredOrders?.length) return;

    const sorter = (a: any, b: any) => {
      if (this.appService.sortBy === "date") {
        const dateA = a.date;
        const dateB = b.date;

        if (!dateA && !dateB) return 0;
        if (!dateA) return this.appService.sortDirection === "asc" ? -1 : 1;
        if (!dateB) return this.appService.sortDirection === "asc" ? 1 : -1;

        const momentA = moment(dateA);
        const momentB = moment(dateB);

        if (momentA.isSame(momentB)) return 0;
        return this.appService.sortDirection === "asc" ? (momentA.isBefore(momentB) ? -1 : 1) : momentA.isBefore(momentB) ? 1 : -1;
      } else {
        const refA = a.description?.toString().toLowerCase() || "";
        const refB = b.description?.toString().toLowerCase() || "";

        if (refA === refB) return 0;
        return this.appService.sortDirection === "asc" ? (refA < refB ? -1 : 1) : refA < refB ? 1 : -1;
      }
    };

    this.filteredOrders.sort(sorter);
  }
}
